import {
  useTranslation as useOriginalTranslation,
  UseTranslationResponse
} from 'react-i18next';
import { useCallback } from 'react';

// 修正 UseTranslationResponse 的泛型类型
type TypedUseTranslationResponse = Omit<UseTranslationResponse<string, undefined>, 't'> & {
  t: (key: string, options?: Record<string, any>) => string;
};

export const useTypedTranslation = (): TypedUseTranslationResponse => {
  const { i18n } = useOriginalTranslation();
  const { t: originalT, ...rest } = useOriginalTranslation();

  // 封装 t 函数，支持动态参数替换
  const t = useCallback((key: string, options?: Record<string, any>): string => {
    const transferT = originalT as any
    let translations = transferT(key, options);
    if (options) {
      Object.keys(options).forEach(f => {
        translations = translations.replaceAll(`{${f}}`,`${options[f]}`)
      })
    }
    return translations;
    //return transferT(key, options);
  }, [originalT]);

  return {
    ...rest,
    t,
    i18n
  };
};
